import FieldProject from "../entity/project/project";
import FieldConfig from "../../proto/field-config";
import FieldTemplateParent_View from "./render/view";

export default class FieldTemplateParent extends FieldProject {

    constructor(config:FieldConfig) {

        super(config);

        this.typeLabel = "TemplateParent";

        this.label     = "TemplateParent";


        this.renderComponents.view = FieldTemplateParent_View;

    }

}
